export const screenTypes = {
  NONE: 'NONE',
  GENERIC: 'GENERIC',
  COMPONENT: 'COMPONENT',
  SOURCE_SYSTEM_DATA: 'SOURCE_SYSTEM_DATA',
  RETURN_TO_INCOME_TAX_SUMMARY: 'RETURN_TO_INCOME_TAX_SUMMARY',
  CUSTOM_SCREEN: 'CUSTOM_SCREEN',
};
